$(function () {
  const qualificationPairs = [
    [
      '#edit-profile-schoolhistory-field-taxquali-subject-passed-und',
      '#edit-profile-schoolhistory-field-taxquali-subject-studying-und'
    ],
    [
      '#edit-profile-schoolhistory-field-accquali-subject-passed-und',
      '#edit-profile-schoolhistory-field-accquali-subject-studying-und'
    ]
  ];

  function preventDuplicateQualificationSelection(passedSelector, studyingSelector) {
    const $passed = $(passedSelector);
    const $studying = $(studyingSelector);

    if (!$passed.length || !$studying.length) return;

    syncDisabled($passed, $studying);

    $passed.add($studying).on('change', ':checkbox', function () {
      syncDisabled($passed, $studying);
    });
  }

  function syncDisabled($passed, $studying) {
    // passed/studying 両方向にdisabled状態を同期する
    [
      [$passed, $studying],
      [$studying, $passed]
    ].forEach(function ([$checkedGroup, $disabledGroup]) {
      const $disabledCheckboxes = $disabledGroup.find(':checkbox');

      $checkedGroup.find(':checkbox').each(function () {
        const value = this.value;
        const disabled = this.checked;

        // 同じ value の checkbox を同一資格として扱う
        $disabledCheckboxes
          .filter(function () {
            return this.value === value;
          })
          .prop('disabled', disabled)
          .closest('.form-item')
          .find('label.option')
          .toggleClass('disabled', disabled);
      });
    });
  }

  qualificationPairs.forEach(function ([passedSelector, studyingSelector]) {
    preventDuplicateQualificationSelection(passedSelector, studyingSelector);
  });
});
